// extracted by mini-css-extract-plugin
module.exports = {"TicketCheckbox":"_2hHH0n_ghnA8uTwSA7fndu","TicketDiv":"_2iozCKOwyBRPN7jtPBgE0o"};